import React from 'react';
import { Alert, Snackbar } from '@mui/material';
import {
  getNkyAppAlertSx,
  nkyAppSnackbarSx,
  nkySnackbarCloseIgnoringClickaway,
} from '../../../constants/nkyAppSnackbar';

/**
 * Message-only brand toast (same styling as service inquiry confirmation).
 * For rich content (extra buttons, layout), use `constants/nkyAppSnackbar.js` on a custom `Alert`, or pass `children`.
 *
 * @param {object} props
 * @param {boolean} props.open
 * @param {() => void} props.onClose — closes the toast (X button, timeout, swipe where supported)
 * @param {'success'|'error'|'warning'|'info'} [props.severity]
 * @param {number} [props.autoHideDuration]
 * @param {React.ReactNode} [props.message] — plain text or nodes when not using `children`
 * @param {React.ReactNode} [props.children] — overrides `message` when provided
 */
function NkySnackbarAlert({
  open,
  onClose,
  severity = 'success',
  autoHideDuration = 6000,
  message,
  children,
}) {
  const body = children ?? message;

  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={nkySnackbarCloseIgnoringClickaway(onClose)}
      sx={nkyAppSnackbarSx}
    >
      <Alert
        onClose={onClose}
        severity={severity}
        variant="filled"
        sx={getNkyAppAlertSx(severity)}
      >
        {body}
      </Alert>
    </Snackbar>
  );
}

export default NkySnackbarAlert;
